// import React, { useEffect, useState, useRef } from "react";
// import HTMLFlipBook from "react-pageflip";
// import Page from "./Page";
// import { fetchPdf } from "./PDFQuery";
// import "./PdfFlipbook.css";
// import backgroundImage from "../../assets/background.jpg";
// import pageFlipSound from "../../assets/turning-page-in-a-book-419580.mp3";

// const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;

// const getUrl = (pathArray) => {
//   if (!pathArray || pathArray.length === 0) return "";
//   const path = pathArray[0];
//   return path.startsWith("http") ? encodeURI(path) : encodeURI(`${BASE_URL}${path}`);
// };


// export default function PdfFlipbook({ setNavbarBg }) {
//   const [menuData, setMenuData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const audioRef = useRef(null);
//   const flipAudioInitRef = useRef(false);

//   // console.log(audioRef);

//   useEffect(() => {
//     let mounted = true;

//     async function loadPdf() {
//       try {
//         const data = await fetchPdf();
      
//         const page = data?.menupage?.[0] ?? null;
//         if (mounted) setMenuData(page);
//       } catch (err) {
//         console.error("PdfFlipbook fetch error:", err);
//         if (mounted) setError(err);
//       } finally {
//         if (mounted) setLoading(false);
//       }
//     }

//     loadPdf();

//     return () => {
//       mounted = false;
//     };
//   }, []);

//   useEffect(() => {
//     if (setNavbarBg) setNavbarBg(`url(${backgroundImage})`);
//   }, [setNavbarBg]);

 

// const handleFlip = () => {
//   try {
//     if (!audioRef.current) {
//       audioRef.current = new Audio(pageFlipSound);
//       audioRef.current.preload = "auto";
//     }
    
//     audioRef.current.currentTime = 0;
    
//     audioRef.current.play().catch((e) => {
//       if (!flipAudioInitRef.current) {
//         flipAudioInitRef.current = true;
//       }
//     });
//   } catch (e) {
//     console.error("Error playing page flip sound:", e);
//   }
// };

//   if (loading) return <p>Loading flipbook...</p>;
//   if (error) return <p>Error loading flipbook</p>;
//   if (!menuData) return <p>No flipbook data available</p>;

  
//   const pages = [];


//   const frontEnabled = menuData.menuFrontCoverEnabled ?? true;
//   const frontCoverUrl = getUrl(menuData.menuFrontCover?.urls);

//   console.log("Before front push:", pages.length);
//   if (frontEnabled && frontCoverUrl) {
//     pages.push({ header: "", image: frontCoverUrl, cover: true });
    
// }



  
//   const middleItems = menuData.pages?.contentItems || [];
//   middleItems.forEach((item, idx) => {
//     const enabled = item?.enabled ?? true;
//     if (!enabled) return;
//     const imgUrl = getUrl(item?.menuImage?.urls);
    
//      if (imgUrl) 
//      pages.push({
//       header: "",
//       image: imgUrl,
//       cover: true,
//       number: pages.length + 1,
//     });
//   });

  
//   const backEnabled = menuData.menuBackCoverEnabled ?? true;
//   const backCoverUrl = getUrl(menuData.menuBackCover?.urls);
//   if (backEnabled && backCoverUrl) {
//     pages.push({ header: "", image: backCoverUrl, cover: true });
//   }

  
//   if (pages.length === 0) {
//     pages.push({ header: "THE END", image: "", cover: true });
//   }
  

//   return (
//     <section
//       id="flipbook-section"
//       className="book-container"
//       style={{ backgroundImage: `url(${backgroundImage})` }}
//     >
//       <HTMLFlipBook
//         className="flipbook"
//         width={700}
//         height={900}
//         showCover={true}
//         onFlip={handleFlip}
//         usePortrait={true}
//         mobileScrollSupport={true}

        
//       >
//         {pages.map((p, index) => (
//           <Page
//             key={index}
//             header={p.header}
//             image={p.image}
//             text={p.text}
//             number={p.number}
//             cover={p.cover}
//           />
//         ))}
               

//       </HTMLFlipBook>
//     </section>
//   );
// }





import React, { useEffect, useState, useRef } from "react";
import HTMLFlipBook from "react-pageflip";
import Page from "./Page";
import { fetchPdf } from "./PDFQuery";
import "./PdfFlipbook.css";
import backgroundImage from "../../assets/background.jpg";
import pageFlipSound from "../../assets/turning-page-in-a-book-419580.mp3";


const BASE_URL = process.env.REACT_APP_CMS_BASE_URL;
const ASPECT_RATIO = 900 / 700; 

const getUrl = (pathArray) => {
  if (!pathArray || pathArray.length === 0) return "";
  const path = pathArray[0];
  return path.startsWith("http") ? encodeURI(path) : encodeURI(`${BASE_URL}${path}`);
};

export default function PdfFlipbook({ setNavbarBg }) {
  const [menuData, setMenuData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [flipbookSize, setFlipbookSize] = useState({ width: 700, height: 900 });
  const audioRef = useRef(null);
  const flipAudioInitRef = useRef(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    let mounted = true;

    async function loadPdf() {
      try {
        const data = await fetchPdf();
        console.log("data=",data);
        const page = data?.menupage?.[0] ?? null;
        if (mounted) setMenuData(page);
      } catch (err) {
        console.error("PdfFlipbook fetch error:", err);
        if (mounted) setError(err);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    loadPdf();

    return () => {
      mounted = false;
    };
  }, []);

  useEffect(() => {
    if (setNavbarBg) setNavbarBg(`url(${backgroundImage})`);
  }, [setNavbarBg]);

  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 800);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const handleFlip = () => {
    // console.log
    try {
      if (!audioRef.current) {
        audioRef.current = new Audio(pageFlipSound);
        audioRef.current.preload = "auto";
      }
      audioRef.current.currentTime = 0;
      audioRef.current.playbackRate = 1.3;
      audioRef.current.play().catch(() => {
        if (!flipAudioInitRef.current) flipAudioInitRef.current = true;
      });
    } catch (e) {
      console.error("Error playing page flip sound:", e);
    }
  };

  
  useEffect(() => {
    const updateSize = () => {
      const maxWidth = Math.min(500, window.innerWidth * 1.1);
      const width = maxWidth;
      const height = width * ASPECT_RATIO;
      setFlipbookSize({ width, height });
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);


  
  if (!menuData) return <p></p>;

  
  console.log(menuData)
  const pages = [];
  const frontEnabled = menuData.menuFrontCoverEnabled ?? true;
  const frontCoverUrl = getUrl(menuData.menuFrontCover?.urls);
  if (frontEnabled && frontCoverUrl) {
    pages.push({ header: "", image: frontCoverUrl, cover: true });
  }

  const middleItems = menuData.pages?.contentItems || [];
  middleItems.forEach((item) => {
    const enabled = item?.enabled ?? true;
    if (!enabled) return;
    const imgUrl = getUrl(item?.menuImage?.urls);
    if (imgUrl) {
      pages.push({
        header: "",
        image: imgUrl,
        cover: false,
        number: pages.length + 1,
      });
    }
  });

  const backEnabled = menuData.menuBackCoverEnabled ?? true;
  const backCoverUrl = getUrl(menuData.menuBackCover?.urls);
  if (backEnabled && backCoverUrl) {
    pages.push({ header: "", image: backCoverUrl, cover: true });
  }

  if (pages.length === 0) {
    pages.push({ header: "THE END", image: "", cover: true });
  }

  return (
    <section
      id="flipbook-section"
      className="book-container"
      >

      <div className="flipbook-wrapper">
      <HTMLFlipBook
        className="flipbook"
        width={flipbookSize.width}
        height={flipbookSize.height}
        showCover={true}
        useMouseEvents={true}
        swipeDistance={0}
        onFlip={handleFlip}
        usePortrait={isMobile}
        mobileScrollSupport={true}
      >
        {pages.map((p, index) => (
          <Page
            key={index}
            header={p.header}
            image={p.image}
            text={p.text}
            number={p.number}
            cover={p.cover}
          />
        ))}
      </HTMLFlipBook>
      </div>
        
    </section>
  );
}
